import React, { useMemo } from "react";
import {
	AiOutlineCheckCircle,
	AiOutlineCloseCircle,
	AiOutlineMinusCircle,
} from "react-icons/ai";
import { useListManager } from "../../contexts/list.manager";
import DownloadIcon from "../DownloadIcon/DownloadIcon";
import SyncIcon from "../SyncIcon/SyncIcon";
import "./ListLine.css";
import { getNestedValue } from "../../policy-engine/utils/object";
import { DynamicIcon } from "../DynamicIcon/DynamicIcon";
import { IoChevronForward } from "react-icons/io5";
import { concatTime, formatDate } from "../../utils/date";
import { useTranslation } from "react-i18next";
import { formatMoney } from "../../utils/number";

const ListLine = ({
	asTableRow = false,
	selectable = true,
	expandableContent = null,
	toggleExpanded = null,
	expandedIds,
	data,
	justify,
	collumsObjIndex,
	listEntityName,
	changeColumnValue,
	listLineColor,
	dualList,
	idx,
}) => {
	const { handleLineClick, lineSelected } = useListManager();
	const { t } = useTranslation();

	const renderObjIndex = useMemo(() => {
		return (
			collumsObjIndex &&
			collumsObjIndex.map((objIndex, idx) => {
				const key = `${objIndex.index}`;
				switch (objIndex.type) {
					case "datetime":
					case "text": //return default
					case "date":
						let value = getNestedValue(data, objIndex.index);

						if (["date", "datetime"].includes(objIndex.type)) {

							value = value ? formatDate(concatTime(value), objIndex.type === "datetime") : null;
						}

						return (
							<span
								key={key}
								className={`list-line-span ${data.icon ? 'list-line-span-with-icon' : ''} ${objIndex.index === "dias_semana" ? "dias-da-semana" : ""
									}`}
								title={value}
								style={{
									width: dualList
										? "100%"
										: objIndex.index === "dias_semana"
											? "130px"
											: "auto",
									textAlign: objIndex.type === "text" ? "center" : "center",
									overflow: lineSelected ? "hidden" : "hidden",
									textOverflow: lineSelected ? "hidden" : "ellipsis",
									'--iconColor': data.color ?? 'var(--textColor)',
								}}
							>
								{/* {data.icon && idx === 0 ? (typeof data.icon === 'string' ? <DynamicIcon iconName={data.icon} /> : data.icon) : null} */}
								{value ? value : (
									<span className="opacity-40">
										{t("common.doesNotContain")}
									</span>
								)}
							</span>
						);
					case "boolean":
						const IconBoolean = getNestedValue(data, objIndex.index)
							? AiOutlineCheckCircle
							: AiOutlineCloseCircle;
						const colorBoolean = getNestedValue(data, objIndex.index)
							? "rgb(1, 219, 1)"
							: "red";
						return (
							<span key={key} className="list-line-span">
								<IconBoolean color={colorBoolean} size={18} />
							</span>
						);
					case "boolean-text":
						return (
							<span key={key} className="list-line-span inline-flex items-center gap-1.5">
								{getNestedValue(data, objIndex.index) ? t("common.yes") : t("common.no")}
							</span>
						);
					case "enabled":
						const IconEnabled = getNestedValue(data, objIndex.index)
							? AiOutlineCheckCircle
							: AiOutlineCloseCircle;
						const colorEnabled = getNestedValue(data, objIndex.index)
							? "rgb(1, 219, 1)"
							: "red";
						return (
							<span key={key} className="list-line-span inline-flex items-center gap-1.5 text-(--iconColor)!" style={{ '--iconColor': colorEnabled }}>
								<IconEnabled color={colorEnabled} size={18} />
								{getNestedValue(data, objIndex.index) ? t("common.enabled") : t("common.disabled")}
							</span>
						);
					case "sync-status":
						return (
							<SyncIcon
								showLabel={objIndex.showLabel || true}
								key={key}
								syncStatus={getNestedValue(data, objIndex.index) ?? ""}
								lastOperation={getNestedValue(data, 'last_operation') ?? getNestedValue(data, 'lastOperation')}
								data={data}
								listEntityName={listEntityName}
							/>
						);
					case "numeric-status":
						const IconStatus =
							getNestedValue(data, objIndex.index) === 1
								? AiOutlineCheckCircle
								: getNestedValue(data, objIndex.index) === 2
									? AiOutlineCloseCircle
									: AiOutlineMinusCircle;
						const colorStatus =
							getNestedValue(data, objIndex.index) === 1
								? "rgb(1, 219, 1)"
								: getNestedValue(data, objIndex.index) === 2
									? "red"
									: "orange";
						return (
							<span key={key} className="list-line-span">
								<IconStatus color={colorStatus} size={18} />
							</span>
						);

					case "download":
						return (
							<DownloadIcon
								key={key}
								listEntityName={listEntityName}
								data={data}
							/>
						);
					case "object":
						const objValue = getNestedValue(data, objIndex.index)
							? getNestedValue(data, objIndex.index)[objIndex.secondIndex]
							: "Nenhum";
						return (
							<span key={key} className="list-line-span">
								{objValue}
							</span>
						);
					case "money":
						let moneyValue = getNestedValue(data, objIndex.index);
						return (
							<span key={key} className="list-line-span">R$ {formatMoney(moneyValue)}</span>
						)
					case "icon":
						const iconValue = getNestedValue(data, objIndex.index);
						console.log('iconValue: ', iconValue, typeof iconValue);
						return (
							<span key={key} className="**:text-(--textColor)!">
								{iconValue && iconValue !== "" ? (typeof iconValue === 'string' ? <DynamicIcon size={18} iconName={iconValue} /> : iconValue) : <span className="opacity-40">{t("common.doesNotContain")}</span>}
							</span>
						);
					case "changeValue":
						const indexFound = changeColumnValue.findIndex(
							(collumnValue) => collumnValue.old === getNestedValue(data, objIndex.index),
						);
						const newValue = changeColumnValue[indexFound]?.new;
						const icon = changeColumnValue[indexFound]?.icon;
						return (
							<span
								key={key}
								className={`list-line-span ${changeColumnValue[indexFound]?.chip ? 'list-line-span-chip' : ''} ${objIndex.index === "dias_semana" ? "dias-da-semana" : ""
									}`}
								style={{
									width: objIndex.index === "dias_semana" ? "200px" : "150px",
									textAlign: objIndex.type === "text" ? "left" : "center",
								}}
							>
								{icon && (typeof icon === 'string' ? <DynamicIcon iconName={icon} /> : icon)}
								{newValue}
							</span>
						);
					default:
						return <div key={key} />;
				}
			})
		);
	}, [data]);

	const lineSelectedStyle =
		lineSelected?.id === data?.id ? "var(--listItemSelectedColor)" : listLineColor;
	const liStyle = {
		backgroundColor: lineSelectedStyle,
		justifyContent: justify === "center" ? "center" : "space-between",
	};

	if (asTableRow) {
		return (
			<tr
				role={selectable ? "button" : "row"}
				className={`list-line not-last:border-b! not-last:border-(--borderColor)! ${selectable ? 'selectable' : ''} ${data._listLineClassName_ ?? ''} ${expandedIds.includes(data.id) ? 'expanded' : ''}`}
				onClick={() => selectable && handleLineClick(data, idx)}
				data-selected={lineSelected?.id && lineSelected?.id === data?.id}
				style={selectable ? {
					backgroundColor: lineSelected?.id === data?.id ? "var(--listItemSelectedColor)" : listLineColor,
				} : {}}
			>
				{collumsObjIndex &&
					collumsObjIndex.map((objIndex, idx) => (
						<td key={`${idx}`} style={{ textAlign: "left" }} className={`${objIndex.columnClassName}`}>
							{objIndex.custom ? objIndex.custom({ row: data }) : renderObjIndex.find((el) => el.key === objIndex.index) || null}
						</td>
					))}
				{expandableContent && (
					<td className={`expandable-toggle ${expandedIds.includes(data._expandableId_ ?? data.id) ? 'expanded' : ''}`}>
						{data._expandable_ && (
							<div className="flex justify-end">
								<button type="button" onClick={(e) => {
									e.stopPropagation();
									toggleExpanded?.(data._expandableId_ ?? data.id);
								}}>
									<IoChevronForward />
									{data._expandableLabel_ ?? "Detalhes"}
								</button>
							</div>
						)}
					</td>
				)}
			</tr>
		);
	}

	return (
		<li
			className={`list-line`}
			onClick={() => selectable && handleLineClick(data, idx)}
			style={liStyle}
		>
			{renderObjIndex}
		</li>
	);
};
export default React.memo(ListLine);
